import { render, staticRenderFns } from "./ApprovalAdCodePreview.vue?vue&type=template&id=4a9966c5&scoped=true"
import script from "./ApprovalAdCodePreview.vue?vue&type=script&lang=js"
export * from "./ApprovalAdCodePreview.vue?vue&type=script&lang=js"
import style0 from "./ApprovalAdCodePreview.vue?vue&type=style&index=0&id=4a9966c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9966c5",
  null
  
)

export default component.exports